/**
 * ============================================================================
 * EXPERIMENT: Calendly Integration (ab_calendly)
 * PR: #TODO_AFTER_PR_CREATION_ab_calendly
 *
 * Navbar button to connect/disconnect Calendly.
 * Temporary code — will be REMOVED when the experiment concludes.
 *
 * Find all experiment code: grep -r "ab_calendly" src/
 * ============================================================================
 */

import { alpha, Button, Chip, paletteColors, Stack } from '@evaneos/b2b-ui';
import { useCallback, useSyncExternalStore } from 'react';
import { Link } from 'react-router-dom';

import CalendarMonthIcon from '@evaneos/b2b-ui/icons/CalendarMonth';
import EventNoteIcon from '@evaneos/b2b-ui/icons/EventNote';

import {
    clearToken,
    initiateOAuth,
    isConnected as checkIsConnected,
    subscribeToTokenChanges,
} from '../../../resources/calendly/AB_calendly-auth';

export function AB_CalendlyNavbarButton(): JSX.Element {
    const connected = useSyncExternalStore(subscribeToTokenChanges, checkIsConnected);

    const handleConnect = useCallback((): void => {
        initiateOAuth();
    }, []);

    if (connected) {
        return (
            <Stack direction="row" alignItems="center" spacing={1} sx={{ marginRight: 1 }}>
                <Button
                    component={Link}
                    to="/calendly/events"
                    variant="outlined"
                    color="inherit"
                    size="small"
                    startIcon={<EventNoteIcon />}
                    data-spec-id="calendly-events-button"
                    sx={{ textDecoration: 'none' }}
                >
                    My Events
                </Button>
                <Chip
                    icon={<CalendarMonthIcon />}
                    label="Connected"
                    size="small"
                    onDelete={clearToken}
                    data-spec-id="calendly-navbar-button"
                    sx={{
                        color: 'inherit',
                        backgroundColor: alpha(paletteColors.neutral[0]!, 0.15),
                        '& .MuiChip-icon': { color: 'inherit' },
                        '& .MuiChip-deleteIcon': {
                            color: alpha(paletteColors.neutral[0]!, 0.6),
                            '&:hover': { color: 'inherit' },
                        },
                    }}
                />
            </Stack>
        );
    }

    return (
        <Button
            variant="outlined"
            color="inherit"
            size="small"
            startIcon={<CalendarMonthIcon />}
            onClick={handleConnect}
            data-spec-id="calendly-navbar-button"
            sx={{ marginRight: 1 }}
        >
            Connecter Calendly
        </Button>
    );
}
